const SoldBadge = ({ compact = false }) => (
  <span
    className={`absolute z-10 rounded bg-[var(--theme-sold-fill)] px-1.5 py-0.5 text-xs font-semibold text-[var(--theme-sold-text)] ${compact ? "bottom-1 left-1" : "bottom-2.5 left-2.5"}`}
  >
    Sold
  </span>
);

export default SoldBadge;
